"use client";

import { FileText, Link as LinkIcon, Newspaper, Search } from "lucide-react";
import { useToolStrings } from "@/components/citation-tool/tool-strings";
import { cn } from "@/lib/utils";

export type InputMode = "auto" | "book" | "search-works" | "manual";

interface InputModeTabsProps {
  mode: InputMode;
  onModeChange: (mode: InputMode) => void;
}

export function InputModeTabs({ mode, onModeChange }: InputModeTabsProps) {
  const s = useToolStrings();
  return (
    <div
      aria-label={s.modeLabel}
      className="grid grid-cols-2 gap-1 rounded-lg bg-muted/50 p-1 sm:flex sm:flex-wrap"
      role="tablist"
    >
      <button
        aria-selected={mode === "auto"}
        className={cn(
          "flex items-center justify-center gap-2 rounded-md px-2 py-2 font-medium text-sm transition-all sm:px-4",
          mode === "auto"
            ? "bg-background text-foreground shadow-soft"
            : "text-muted-foreground hover:text-foreground"
        )}
        onClick={() => onModeChange("auto")}
        role="tab"
        type="button"
      >
        <LinkIcon className="size-4" />
        {s.modeAuto}
      </button>
      <button
        aria-selected={mode === "book"}
        className={cn(
          "flex items-center justify-center gap-2 rounded-md px-2 py-2 font-medium text-sm transition-all sm:px-4",
          mode === "book"
            ? "bg-background text-foreground shadow-soft"
            : "text-muted-foreground hover:text-foreground"
        )}
        onClick={() => onModeChange("book")}
        role="tab"
        type="button"
      >
        <Search className="size-4" />
        {s.modeBook}
      </button>
      <button
        aria-selected={mode === "search-works"}
        className={cn(
          "flex items-center justify-center gap-2 rounded-md px-2 py-2 font-medium text-sm transition-all sm:px-4",
          mode === "search-works"
            ? "bg-background text-foreground shadow-soft"
            : "text-muted-foreground hover:text-foreground"
        )}
        onClick={() => onModeChange("search-works")}
        role="tab"
        type="button"
      >
        <Newspaper className="size-4" />
        {s.modeArticles}
      </button>
      <button
        aria-selected={mode === "manual"}
        className={cn(
          "flex items-center justify-center gap-2 rounded-md px-2 py-2 font-medium text-sm transition-all sm:px-4",
          mode === "manual"
            ? "bg-background text-foreground shadow-soft"
            : "text-muted-foreground hover:text-foreground"
        )}
        onClick={() => onModeChange("manual")}
        role="tab"
        type="button"
      >
        <FileText className="size-4" />
        {s.modeManual}
      </button>
    </div>
  );
}
